import { render, staticRenderFns } from "./ContactSection2.vue?vue&type=template&id=b68d4bb6&scoped=true&"
import script from "./ContactSection2.vue?vue&type=script&lang=js&"
export * from "./ContactSection2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68d4bb6",
  null
  
)

export default component.exports